export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "Estatísticas de fluxo turístico — relatórios regionais",

  fields: {
    region: "Região",
    codice: "Código da estrutura",
    codiceHint: "Código da estrutura atribuído pela região (o campo «codice»).",
    username: "Nome de usuário",
    password: "Senha",
    passwordHint: "Credenciais do web service do ROSS 1000 (emitidas pela região / GIES).",
    prodotto: "Nome do software",
    camereDisponibili: "Quartos disponíveis",
    lettiDisponibili: "Camas disponíveis",
    defaultTipoturismo: "Tipo de turismo (padrão)",
    defaultMezzotrasporto: "Meio de transporte (padrão)",
    useTestEndpoint: "Usar ambiente de teste",
    endpointResolved: "Endpoint",
    keepBlank: "(deixe em branco para manter o atual)",
  },

  regionOptions: {
    sardegna: "Sardenha",
    lazio: "Lácio",
    veneto: "Vêneto",
    emilia_romagna: "Emília-Romanha",
    toscana: "Toscana",
    piemonte: "Piemonte",
    lombardia: "Lombardia",
    liguria: "Ligúria",
    marche: "Marche",
    abruzzo: "Abruzzo",
    molise: "Molise",
    calabria: "Calábria",
    basilicata: "Basilicata",
  },

  actions: {
    saveAndVerify: "Salvar e verificar",
    updateCredentials: "Atualizar credenciais",
    verifyConnection: "Verificar conexão",
    saving: "Salvando...",
    verifying: "Verificando...",
  },

  status: {
    connectionOk: "Credenciais salvas e conexão verificada com sucesso.",
    connectionError: "Erro de conexão. Verifique as credenciais informadas.",
    connectionPending: "Conexão ainda não verificada. Clique em «Verificar conexão» para confirmar.",
  },

  validation: {
    codiceRequired: "O código da estrutura é obrigatório.",
    usernameRequired: "O nome de usuário é obrigatório.",
    passwordRequired: "A senha é obrigatória.",
    capacityRequired: "Informe os quartos e camas disponíveis.",
  },

  toasts: {
    saveSuccess: "Credenciais salvas e conexão verificada com sucesso.",
    saveWarning: "Credenciais salvas, mas não foi possível verificar a conexão.",
    saveError: "Não foi possível salvar as credenciais.",
    testSuccess: "Conexão com o ROSS 1000 verificada com sucesso.",
    testError: "Não foi possível verificar a conexão.",
    statusActive: "ROSS 1000 ativado.",
    statusInactive: "ROSS 1000 desativado.",
  },
};